import React, { useMemo } from "react";

interface BulletPointListProps {
  text: string | string[]; // The plain text input
  delimiter?: string; // Optional delimiter, defaults to newline
}

const BulletPointList: React.FC<BulletPointListProps> = ({
  text,
  delimiter = "\n",
}) => {
  // Split the text into an array using the provided delimiter
  const items = useMemo(() => {
    if (typeof text === "string") {
      return text.split(delimiter).filter((item) => item.trim() !== "");
    } else {
      return text;
    }
  }, [delimiter, text]);

  if (items.length === 0) {
    return null;
  }

  return (
    <ul style={{ paddingRight: 20, paddingLeft: 20 }}>
      {items.map((item, index) => (
        <li key={index} style={{ paddingBottom: 6 }}>
          {item.trim()}
        </li>
      ))}
    </ul>
  );
};

export default BulletPointList;
